import React, { useCallback } from 'react';
import moment from 'moment';
import ListarDatos from '../../../../general/ListarDatos';
import { BtnVer } from '../../../../general/BotonesAccion';
import { COLORES_ESTADO } from '../../../helper';

const DEFAULT_AVATAR = { backgroundColor: '#B8B8B8', color: '#FFFFFF' };

function DetalleHistorialEstudianteTab({ historial, transferirSolicitud, abrirDetalleRemision }) {
    const handleVer = useCallback(async (row) => {
        if (typeof transferirSolicitud === 'function') {
            transferirSolicitud(row);
            return;
        }
        if (typeof abrirDetalleRemision === 'function') {
            await abrirDetalleRemision(row.id);
        }
    }, [transferirSolicitud, abrirDetalleRemision]);

    return (
        <ListarDatos
            datos={historial}
            id='tbl_historial_estudiante_bienestar'
            avatar={({ estado_actual }) => estado_actual?.nombre ? estado_actual?.nombre.charAt(0).toUpperCase() : ''}
            color_avatar={({ estado_actual }) => COLORES_ESTADO[estado_actual?.tipo_estado?.codigo] || DEFAULT_AVATAR}
            fila_principal={({ usuario_registro }) => usuario_registro
                ? `${usuario_registro.primer_nombre} ${usuario_registro.primer_apellido} ${usuario_registro.segundo_apellido}`
                : 'Usuario Desconocido'}
            filas={[
                { id: 'tipo_solicitud', mostrar: ({ tipo_solicitud }) => tipo_solicitud?.nombre || '' },
                { id: 'tipo_servicio', nombre: 'Servicio: ', mostrar: ({ tipo_servicio }) => tipo_servicio?.nombre || '' },
                { id: 'fecha_registro', nombre: 'Fecha: ', mostrar: ({ fecha_registro }) => moment(fecha_registro).format('YYYY-MM-DD, h:mm a') },
            ]}
            acciones={(row) => <BtnVer callback={() => handleVer(row)} />}
        />
    );
}

export default React.memo(DetalleHistorialEstudianteTab);
